if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.productInfoContainer = this;
        this.variantData = []
        const productVariantsSection = document.getElementById(`ProductVariants-${this.sectionId}`);
        if (productVariantsSection?.textContent) {
          this.variantData = JSON.parse(productVariantsSection.textContent);
        }
      }

      connectedCallback() {
        const selectedVariant = this.getSelectedVariant(this);

        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.updateFindMyShadeBtn();

        this.maintainSwatchOnSizeToggle();

        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        customElements.whenDefined('product-form').then(async () => {
          this.updateButtonState(document, selectedVariant);

          const bundleInputs = this.querySelectorAll('input.bundle-swatch');
          if (bundleInputs.length > 0) {
            await window.updateDuplicateBundleSwatchAvailability?.(this, { forceFetch: true, deductCartQuantities: false });
            this.disableBundleToggle(this.selectedVariantInventoryOnLoad, this.selectedVariantDiscontinuedOnLoad);
          } else {
            const selectedOptions = {};
            this.querySelectorAll('.product-variant-picker fieldset').forEach((fieldset, index) => {
              const checkedInput = fieldset.querySelector('input:checked');
              selectedOptions[index] = checkedInput?.value || null;
            });
            if (Object.keys(selectedOptions).length > 0) {
              this.updateSwatchAvailability(selectedOptions);
            }
          }
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.quantitySyncUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

    updateSwatchAvailability(selectedOptions) {
      const swatchInputs = this.querySelectorAll('.product-variant-picker .swatch-input__input');

      swatchInputs.forEach(input => {
        const index = parseInt(input.dataset.optionIndex, 10);
        const value = input.value;
        const hypotheticalSelection = { ...selectedOptions, [index]: value };

        const isExactComboAvailable = this.variantData.some(variant => {
          if (!variant.available) return false;
          return Object.entries(hypotheticalSelection).every(([i, val]) => variant.options[i] === val);
        });

        const shouldStrike = !isExactComboAvailable;

        if (shouldStrike) {
          input.classList.add('visually-disabled', 'shade--not-available');
        } else {
          input.classList.remove('visually-disabled', 'shade--not-available');
        }
      });
    }


      disableBundleToggle(available, discontinued) {
        const productForm = this.productForm;
        const selectedAvailability = this.selectedVariantInventoryOnLoad;
        const selectedDiscontinued = this.selectedVariantDiscontinuedOnLoad;
        const availability = selectedAvailability.length ? selectedAvailability : available || [];
        const discontinuedList = selectedDiscontinued.length ? selectedDiscontinued : discontinued || [];
        const anyFalse = availability.some(item => item === "false");
        const anyDiscontinued = discontinuedList.some(item => item === "true");
        const bundleMasterProductDiscontinued = productForm.dataset.discontinued === "true";
        const bundleMasterProductAvailable = productForm.dataset.bundleAvailable === "true";
        this.updateBundleOosMessage(anyFalse && !anyDiscontinued);
        if (typeof productForm?.toggleSubmitButton === "function") {
          if (bundleMasterProductDiscontinued && anyFalse ||!bundleMasterProductAvailable && bundleMasterProductDiscontinued ) { // uses the bundle master or variant custom metafield: discontinued
            productForm.toggleSubmitButton(bundleMasterProductDiscontinued, window.variantStrings.soldOut);
          } else if (!bundleMasterProductAvailable && !bundleMasterProductDiscontinued) {
            productForm.toggleSubmitButton(anyDiscontinued, window.variantStrings.joinTheWaitlist)
          } else if (availability.length > 0) {
            if (anyFalse) {
              if (anyDiscontinued) {
                productForm.toggleSubmitButton(anyDiscontinued, window.variantStrings.soldOut);
              } else {
                productForm.toggleSubmitButton(anyFalse, window.variantStrings.joinTheWaitlist)
              }
            } else {
              const forceJoinWaitlist = productForm?.dataset?.forceJoinWaitlist === 'true';
              productForm.toggleSubmitButton(anyFalse, forceJoinWaitlist ? window.variantStrings.joinTheWaitlist : window.variantStrings.addToCart)
            }
          } else {
            productForm.toggleSubmitButton(anyFalse, window.variantStrings.joinTheWaitlist)
          }

        } else {
          console.warn("toggleSubmitButton is not a function on productForm");
        }
      }

      updateBundleOosMessage(showMessage) {
        const productForm = this.productForm;
        const formContainer = productForm?.closest('.product-form__container') || productForm;
        const buttonsContainer = productForm?.querySelector('.product-form__buttons');
        const submitButton = buttonsContainer?.querySelector('button[name="add"]');
        const generalOosMessage = formContainer?.querySelector('.product-form__oos-message');
        let bundleOosMessage = buttonsContainer?.querySelector('.oos-bundle');
        const hasStaticBundleOosMessage = !!bundleOosMessage && bundleOosMessage.dataset.dynamicBundleOos !== 'true';
        const shouldShowMessage = showMessage || hasStaticBundleOosMessage;

        generalOosMessage?.classList.toggle('hidden', !shouldShowMessage);
        buttonsContainer?.classList.toggle('oos-bundle-container', !!shouldShowMessage);

        if (!buttonsContainer || !submitButton) return;

        if (!bundleOosMessage && showMessage) {
          bundleOosMessage = document.createElement('div');
          bundleOosMessage.className = 'oos-bundle';
          bundleOosMessage.dataset.dynamicBundleOos = 'true';
          bundleOosMessage.textContent = window.variantStrings?.bundleOos ||
            'One or more items in this set is out of stock. Join the waitlist to be notified when this set is back in stock.';
          buttonsContainer.insertBefore(bundleOosMessage, submitButton);
        }

        bundleOosMessage?.classList.toggle('hidden', !shouldShowMessage);
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues, selectedVariantInventory, selectedVariantDiscontinued} }) {
        if (!this.contains(event.target)) return;

        if (target.getAttribute('name').includes('upsell-swatch')) return;

        const isEditingBundle = this.querySelector('.bundle-product') !== null;
        if (isEditingBundle) {
          this.disableBundleToggle(selectedVariantInventory, selectedVariantDiscontinued);
          return
        };

        const container = target.getAttribute('data-quickview') === 'true' ? target.closest('modal-dialog') : document;
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        const allOptionValues = Array.from(this.querySelectorAll('input[type="radio"]:checked, select'))
        .map(el => {
          if (el.tagName === 'SELECT') {
            return el.selectedOptions[0]?.dataset.optionValueId;
          } else {
            return el.dataset.optionValueId;
          }
        })
        .filter(Boolean);

        // Sync the main ATB form's variant id immediately so a fast click submits the correct shade before the fetch resolves. TARTE-17884
        const immediateVariantId = shouldSwapProduct ? null : this.resolveSelectedVariantId();
        if (immediateVariantId) {
          const mainFormIdInput = this.querySelector(
            `#product-form-${this.dataset.section} input[name="id"]`
          );
          if (mainFormIdInput) mainFormIdInput.value = String(immediateVariantId);
        }

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, allOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: (html) => {
            const selectedVariantId = this.getSelectedVariant(html.querySelector('product-info'));
            const userSelectedVariantId = sessionStorage.getItem('userSelectedVariant');
            if (userSelectedVariantId) {
              selectedVariantId.id = userSelectedVariantId;
            }

            shouldSwapProduct ? this.handleSwapProduct(productUrl, shouldFetchFullPage)(html) : this.handleUpdateProductInfo(productUrl)(html);

            this.updateVariantImages(selectedVariantId);
            this.updateSelectedSwatch(selectedVariantId.id, container);
            this.updateSelectedShadeLabel(selectedVariantId);
            this.updateProductFormOosLabel(selectedVariantId);
            const selectedOptions = {};
            this.querySelectorAll('.product-variant-picker fieldset').forEach((fieldset, index) => {
              const checkedInput = fieldset.querySelector('input:checked');
              selectedOptions[index] = checkedInput?.value || null;
            });

            this.updateSwatchAvailability(selectedOptions);
            this.dataset.selectedVariantId = selectedVariantId.id;
            this.dataset.sellingPlanExists = selectedVariantId.selling_plan_allocations.length > 0 ? true : false;

            if (target.getAttribute('data-quickview') !== 'true') {
              window.addSwatchBadge();
            }
            document.dispatchEvent(new CustomEvent('swatchChange', { detail: { selectedVariant : selectedVariantId }}));
          }
        });
      }

      get selectedVariantInventoryOnLoad() {
        return Array.from(this.querySelectorAll('.non-bundle-input:checked, fieldset input:checked')).map(
          ({ dataset }) => dataset.variantAvailable
        );
      }

      get selectedVariantDiscontinuedOnLoad() {
        return Array.from(this.querySelectorAll('.non-bundle-input:checked, fieldset input:checked')).map(
          ({ dataset }) => dataset.variantDiscontinued
        );
      }

      resetProductFormState() {
        const productForm = this.productForm;
        if (typeof productForm?.toggleSubmitButton === "function" && typeof productForm?.handleErrorMessage === "function" ) {
          productForm.toggleSubmitButton(true);
          productForm.handleErrorMessage();
        }
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateVariantDataFromHtml(html);
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
              this.restoreButtonStateFromSelection();
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        if (!productInfoNode) return null;
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      // Resolve the selected variant id from checked option controls via client-side data; null when unresolved. TARTE-17884
      resolveSelectedVariantId() {
        if (!Array.isArray(this.variantData) || !this.variantData.length) return null;

        const controls = this.querySelectorAll(
          '.product-variant-picker input[type="radio"]:checked, .product-variant-picker select'
        );
        if (!controls.length) return null;

        const selectedOptions = {};
        for (const el of controls) {
          const index = parseInt(el.dataset.optionIndex, 10);
          if (Number.isNaN(index)) return null; // can't reliably resolve; fall back to async update
          selectedOptions[index] = el.value;
        }

        const match = this.variantData.find((variant) =>
          Object.entries(selectedOptions).every(([i, val]) => variant.options[i] === val)
        );
        return match?.id ?? null;
      }

      restoreButtonStateFromSelection() {
        const selectedId = this.resolveSelectedVariantId();
        const variant = selectedId ? this.variantData.find((v) => v.id === selectedId) : null;
        const buttonText = variant?.available
          ? window.variantStrings.addToCart
          : window.variantStrings.joinTheWaitlist;
        this.productForm?.toggleSubmitButton(false, buttonText);
        this.productForm?.setExpressCheckoutHidden(
          !variant?.available || this.productForm?.dataset?.forceJoinWaitlist === 'true'
        );
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      maintainSwatchOnSizeToggle() {
        const shadeInputs = document.querySelectorAll(".product-form__input input[name='pdp-swatch-color']");
        const sizeLinks = document.querySelectorAll(".product-size.secondary");
        const normalize = (str) => str ? str.trim().toLowerCase() : '';
        
        // Helper function to find the nearest available swatch
        const findNearestAvailableSwatch = (targetShade, availableVariants, currentShadeInputs) => {
          const availableShades = availableVariants
            .filter(v => v.available && v.option1)
            .map(v => v.option1.toLowerCase().trim());
      
          if (availableShades.length === 0) return null;
          const swatchOrder = Array.from(currentShadeInputs).map(input => 
            input.value.trim().toLowerCase()
          );
          // Find the index of the target shade in the current swatch order
          const targetIndex = swatchOrder.indexOf(targetShade);
          if (targetIndex === -1) {
            return availableShades[0];
          }
          for (let offset = 0; offset < swatchOrder.length; offset++) {
            // Check right side first
            if (targetIndex + offset < swatchOrder.length) {
              const rightShade = swatchOrder[targetIndex + offset];
              if (availableShades.includes(rightShade)) {
                return rightShade;
              }
            }
            // Check left side
            if (offset > 0 && targetIndex - offset >= 0) {
              const leftShade = swatchOrder[targetIndex - offset];
              if (availableShades.includes(leftShade)) {
                return leftShade;
              }
            }
          }
          // Fallback to first available if no nearby match found
          return availableShades[0];
        };
      
        sizeLinks.forEach(link => {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            let selectedShade = null;
            shadeInputs.forEach(input => {
              if (input.checked) {
                selectedShade = input.value.trim().toLowerCase();
              }
            });
            if (!selectedShade) {
              // No shade selected, fallback to normal redirect
              window.location.href = this.href;
              return;
            }
            const relatedUrl = this.href;
            const relatedJsonUrl = relatedUrl + ".js";
      
            fetch(relatedJsonUrl)
              .then(res => res.json())
              .then(data => {
                // First check if variant exists in product data
                const matchingVariant = data.variants.find(v => {
                  return v.option1 && normalize(v.option1) === normalize(selectedShade);
                });
                
                if (matchingVariant) {
                  // Variant exists in data, but also check if it exists in the DOM
                  fetch(relatedUrl)
                    .then(response => response.text())
                    .then(html => {
                      const parser = new DOMParser();
                      const targetDoc = parser.parseFromString(html, 'text/html');
                      
                      // Check if the shade exists in the target page's swatch inputs
                      const targetShadeInputs = targetDoc.querySelectorAll(".product-form__input input[name='pdp-swatch-color']");
                      const targetShades = Array.from(targetShadeInputs).map(input => normalize(input.value));     
                      const shadeExistsInDOM = targetShades.includes(normalize(selectedShade));
                      
                      if (shadeExistsInDOM) {
                        // Shade exists in both data and DOM - proceed normally
                        window.location.href = `${relatedUrl}?variant=${matchingVariant.id}`;
                      } else {
                        // Shade exists in data but not in DOM - find nearest available
                        const availableVariantsInDOM = data.variants.filter(v => {
                          return v.available && 
                                 v.option1 && 
                                 targetShades.includes(normalize(v.option1));
                        });            
                        const nearestShade = findNearestAvailableSwatch(selectedShade, availableVariantsInDOM, shadeInputs);
                        if (nearestShade) {
                          const nearestVariant = availableVariantsInDOM.find(v => {
                            return normalize(v.option1) === normalize(nearestShade);
                          });
                          if (nearestVariant) {
                            window.location.href = `${relatedUrl}?variant=${nearestVariant.id}`;
                          } else {
                            window.location.href = relatedUrl;
                          }
                        } else {
                          window.location.href = relatedUrl;
                        }
                      }
                    })
                    .catch(err => {
                      console.error("Error fetching target page HTML:", err);
                      // If we can't check the DOM, assume shade doesn't exist and find nearest
                      const nearestShade = findNearestAvailableSwatch(selectedShade, data.variants, shadeInputs);
                      if (nearestShade) {
                        const nearestVariant = data.variants.find(v => {
                          return v.option1 && normalize(v.option1) === normalize(nearestShade) && v.available;
                        });
                        if (nearestVariant) {
                          window.location.href = `${relatedUrl}?variant=${nearestVariant.id}`;
                        } else {
                          window.location.href = relatedUrl;
                        }
                      } else {
                        window.location.href = relatedUrl;
                      }
                    });
                } else {
                  // Variant doesn't exist in data at all - find nearest available
                  const nearestShade = findNearestAvailableSwatch(selectedShade, data.variants, shadeInputs);
                  if (nearestShade) {
                    const nearestVariant = data.variants.find(v => {
                      return v.option1 && normalize(v.option1) === normalize(nearestShade) && v.available;
                    });
                    if (nearestVariant) {
                      window.location.href = `${relatedUrl}?variant=${nearestVariant.id}`;
                    } else {
                      window.location.href = relatedUrl;
                    }
                  } else {
                    window.location.href = relatedUrl;
                  }
                }
              })
              .catch(err => {
                console.error("Error fetching variant data:", err);
                window.location.href = relatedUrl;
              });
          });
        });
      }

      updateVariantImages(variant) {
        const productHandle = window.productHandle;
        const url = `/products/${productHandle}`;
        const variantId = variant.id;
        const variantSku = variant.sku;

        const variantUrl = `${url}${variantId ? `?view=media-gallery&variant=${variantId}` : ''}`;

        let container;

        const isQuickviewCart = this.closest('#quickshop-cart') !== null;
        const isQuickview = this.closest('#quickshop') !== null;
        const isBuildKitQuickview = this.closest('#buildkit-quickshop') !== null;
        const isCustomKitQuickview = this.closest('#custom-kit-quickshop') !== null;

        if(isQuickviewCart) {
          container = document.querySelector(`#quickshop-cart .product-media-gallery`)
        } else if (isQuickview) {
          container = document.querySelector(`#quickshop .product-media-gallery`)
        } else if (isBuildKitQuickview) {
          container = document.querySelector(`#buildkit-quickshop .product-media-gallery`)
        } else if (isCustomKitQuickview) {
          container = document.querySelector(`#custom-kit-quickshop .product-media-gallery`)
        } else {
          container = document.querySelector(`.product-section .product-media-gallery`)
        }

        let currentMediaGallery = container;

        currentMediaGallery?.setAttribute('data-selected-variant-id', variantId);
        currentMediaGallery?.setAttribute('data-selected-variant-sku', variantSku);

        fetch(variantUrl)
            .then(response => response.text())
            .then(html => {
                const variantHtml = new DOMParser().parseFromString(html, 'text/html');
                const mediaGallery = variantHtml.querySelector(`.product-media-gallery`);

                if (currentMediaGallery && mediaGallery) {
                    currentMediaGallery.innerHTML = mediaGallery.innerHTML;
                }

                if (typeof window.initLazyLoadingVideo === 'function') window.initLazyLoadingVideo();

                if(isQuickviewCart) {
                  window.initSwiper('#quickshop-cart');
                  window.addProductBadges('#quickshop-cart');
                } else if (isQuickview) {
                  window.initSwiper('#quickshop');
                  window.addProductBadges('#quickshop');
                } else if (isBuildKitQuickview) {
                  window.initSwiper('#buildkit-quickshop');
                  window.addProductBadges('#buildkit-quickshop');
                } else if (isCustomKitQuickview) {
                  window.initSwiper('#custom-kit-quickshop');
                  window.addProductBadges('#custom-kit-quickshop');
                } else {
                  window.initSwiper('.product-section');
                  window.addProductBadges('.product-section');
                }
                this.updateFindMyShadeBtn();
            })
            .catch(error => {
                console.error('Error fetching updated media gallery:', error);
            });
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.updateVariantDataFromHtml(html);
          this.pickupAvailability?.update?.(variant);
          // this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id)

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('price-mobile');
          updateSourceFromDestination('price-desktop');

          ['price-mobile', 'price-desktop'].forEach((id) => {
            const block = this.querySelector(`#${id}-${this.dataset.section}`);
            if (!block) return;
            if (typeof window.RegiosHelper?.setPriceContainersVisible === 'function') {
              window.RegiosHelper.setPriceContainersVisible(block);
            } else {
              block.querySelectorAll('.price__container').forEach((el) => {
                el.style.visibility = 'visible';
              });
            }
          });

          updateSourceFromDestination('ValueSave');
          updateSourceFromDestination('VariantPdpMessage');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.updateButtonState(html, variant);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          this.syncRegiosPricing();
          this.dispatchEvent(new CustomEvent('product-info:dom-updated', { bubbles: true }));
        };
      }

      syncRegiosPricing() {
        const productJsonEl = this.querySelector('.product-json-data');
        const activeInput = this.querySelector('input.shade-input:checked');

        if (!productJsonEl || !activeInput?.dataset?.variantId) return;

        try {
          const productData = JSON.parse(productJsonEl.textContent);
          window.RegiosHelper?.syncVariantPricing?.({
            product: productData,
            selectedVariantId: Number(activeInput.dataset.variantId),
            container: this,
            quantity: Number(this.quantityInput?.value) || 1,
          });
        } catch (err) {
          console.warn('Failed to parse product JSON for Regios update:', err);
        }
      }

      updateVariantInputs(variantId, { notify = true } = {}) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;

          const previousValue = input.value;
          const nextValue = String(variantId ?? '');

          input.value = nextValue;

          if (notify && previousValue !== nextValue) {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        const quickview = this.closest('#Quickshop-Modal');
        const cartQuickview = this.closest('#Quickshop-Modal-cart');
        if (this.dataset.updateUrl === 'false' || !!quickview || !!cartQuickview) return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
        this.productForm?.setExpressCheckoutHidden(true);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateButtonState(html, selectedVariant) {
        const isSoldOut = !selectedVariant || !selectedVariant.available;
        const isDiscontinued = html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled');
        const forceJoinWaitlist = this.productForm?.dataset?.forceJoinWaitlist === 'true';

        // Buy Now visibility: use the flag buy-buttons.liquid rendered for the selected variant.
        const renderedExpressCheckoutFlag = html
          .getElementById(`ProductSubmitButton-${this.sectionId}`)
          ?.getAttribute('data-express-checkout-hidden');
        this.productForm?.setExpressCheckoutHidden(
          renderedExpressCheckoutFlag !== null && renderedExpressCheckoutFlag !== undefined
            ? renderedExpressCheckoutFlag === 'true'
            : isSoldOut || isDiscontinued || forceJoinWaitlist
        );

        let buttonText;
        if (forceJoinWaitlist) {
          buttonText = window.variantStrings.joinTheWaitlist;
        } else if (isDiscontinued) {
          buttonText = window.variantStrings.soldOut;
        } else if (isSoldOut) {
          buttonText = window.variantStrings.joinTheWaitlist;
        } else {
          buttonText = window.variantStrings.addToCart;
        }

        this.productForm?.toggleSubmitButton(isDiscontinued && !forceJoinWaitlist, buttonText);
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        this.querySelector(`.product-media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
        );

        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

     updateSelectedSwatch(variantId, container = document) {
        const swatchInputs = container.querySelectorAll('.shade-input');
        const nameGroups = {};

        swatchInputs.forEach(input => {
          const name = input.name;
          if (!nameGroups[name]) nameGroups[name] = [];
          nameGroups[name].push(input);
        });

        for (const name in nameGroups) {
          const group = nameGroups[name];
          const selectedInput = group.find(input => input.dataset.variantId === variantId);

          if (selectedInput) {
            group.forEach(input => {
              input.checked = input === selectedInput;
              input.setAttribute('data-selected-by-user', input === selectedInput ? 'true' : 'false');
            });
          }
        }
      }

      updateSelectedShadeLabel(variant) {
        const shadeNotAvailableElement = document.querySelector('.product-form__shade-value .shade-value--not-available');
        const shadeInputSwatch = document.querySelector('.product-form__input--swatch');

        if (shadeNotAvailableElement && !variant.available) {
          shadeNotAvailableElement?.classList.remove('hidden');
          shadeInputSwatch?.classList.add('product-form__input--swatch-not-available');
        } else {
          shadeNotAvailableElement?.classList.add('hidden');
          shadeInputSwatch?.classList.remove('product-form__input--swatch-not-available');
        }
      }

      updateProductFormOosLabel(variant) {
        if (variant) {
          const productFormOosMessage = document.querySelector('.buy-buttons .product-form__oos-message');
          if (productFormOosMessage) {
            if(!variant.available) {
              productFormOosMessage.classList.remove('hidden');
            } else {
              productFormOosMessage.classList.add('hidden');
            }
          } 
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      updateFindMyShadeBtn() {
        const findMyShadeOpener = this.querySelector('.product__find-my-shade-modal-opener');
        const vtoOpener = this.querySelector('.product__vto-modal-opener');

        if (findMyShadeOpener) {
          findMyShadeOpener.classList.remove('hidden');
          vtoOpener?.classList.add('hidden');
        } else if (vtoOpener) {
          vtoOpener.classList.remove('hidden');
        }
      }

      updateVariantDataFromHtml(html) {
        const variantScript = html.getElementById(`ProductVariants-${this.sectionId}`);
        if (variantScript?.textContent) {
          try {
            const parsed = JSON.parse(variantScript.textContent);
            if (Array.isArray(parsed)) {
              this.variantData = parsed;
            } else {
              console.warn('[updateVariantDataFromHtml] parsed variant data is not array:', parsed);
            }
          } catch (e) {
            console.error('Failed to parse variantData from HTML', e);
          }
        } else {
          console.warn(`[updateVariantDataFromHtml] Missing script tag: #ProductVariants-${this.sectionId}`);
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
